import React from 'react';
import PropTypes from 'prop-types';
import { Button as AbyssButton } from '@uhg-abyss/web/ui/Button';

export const Button = ({ children, variant, color, ...props }) => {
  if (variant === 'tertiary') {
    return (
      <AbyssButton {...props} variant={variant}>
        {children}
      </AbyssButton>
    );
  }
  return (
    <AbyssButton {...props} variant={variant} color={color}>
      {children}
    </AbyssButton>
  );
};

Button.propTypes = {
  children: PropTypes.node,
  variant: PropTypes.string,
  color: PropTypes.string,
};

Button.defaultProps = {
  children: null,
  variant: 'solid',
  color: 'primary1',
};
